<template>
  <v-row class="my-0">
    <v-col cols="4">
      <v-text-field
        outlined
        dense
        type="number"
        required
        data-testid="routineChecklist-input-scaleMin"
        :label="`${$t('checklist.min')}*`"
        :rules="rules"
        :value="min"
        :error-messages="errorMessage"
        @input="handleInput({ min: $event.length ? parseInt($event) : null })"
        @change="handleCommit({ min: $event.length ? parseInt($event) : null })"
      />
    </v-col>
    <v-col cols="1" class="d-flex justify-center mt-2">
      <p class="body-1 blue-grey--text text--darken-3 ma-0 pa-0">
        {{ $t('common.to') }}
      </p>
    </v-col>
    <v-col cols="4">
      <v-text-field
        outlined
        dense
        type="number"
        required
        data-testid="routineChecklist-input-scaleMax"
        :label="`${$t('checklist.max')}*`"
        :rules="rules"
        :value="max"
        :error-messages="errorMessage"
        @input="handleInput({ max: $event.length ? parseInt($event) : null })"
        @change="handleCommit({ max: $event.length ? parseInt($event) : null })"
      />
    </v-col>
  </v-row>
</template>
<script>
import _ from 'lodash'

export default {
  name: 'Scale',

  props: {
    min: { required: false },
    max: { required: false, default: null },
  },

  data() {
    return {
      rules: [
        value =>
          this.minIsInteger(value) ||
          this.$t('validation.form.this_field_is_required'),
      ],
    }
  },

  computed: {
    errorMessage() {
      return this.max && this.max < this.min
        ? this.$t('checklist.scale.error')
        : ''
    },
  },

  methods: {
    minIsInteger(value) {
      const int = parseInt(value)
      return _.isInteger(int)
    },

    maxIsInteger(value) {
      const int = parseInt(value)
      return _.isInteger(int)
    },

    handleInput(value) {
      this.$emit('change', value)
    },

    // Committed edit (blur/Enter): fired in addition to the legacy
    // per-keystroke `change` so consumers can defer confirmation dialogs
    // to a complete value instead of the first keystroke.
    handleCommit(value) {
      this.$emit('commit', value)
    },
  },
}
</script>
